// Module
var code = "<div class=\"switch\"> <label class=\"toggle\"> <input type=\"checkbox\" class=\"filled-in\"/> <span class=\"lever\"></span> <span class=\"description\">{{ description }}</span> </label> </div> ";
// Exports
export default code;